<script setup lang="ts">
import { ref, computed } from 'vue';
import AuthLayout from '../components/AuthLayout.vue';
import { Button, Input } from '../components/ui';
import { resendUnlock } from '../api';
import { isValidEmail } from '../services/validators';

const email = ref('');
const emailError = ref('');
const loading = ref(false);
const success = ref(false);

const topLinks = computed(() => {
  if (success.value) {
    return [{ url: '/users/sign_in', text: 'Back to Login' }];
  }
  return [
    { url: '/users/sign_in', text: 'Sign In' },
    { url: '/users/password/new', text: 'Forgot password?' },
    { url: '/users/confirmation/new', text: "Didn't receive confirmation instructions?" },
  ];
});

const bottomLinks = computed(() => {
  if (success.value) return [];
  return [{ url: '/users/request', text: 'Not a member yet? Request access' }];
});

async function handleSubmit() {
  emailError.value = '';

  if (!isValidEmail(email.value)) {
    emailError.value = 'Enter a valid email.';
    return;
  }

  loading.value = true;

  try {
    await resendUnlock(email.value);
    success.value = true;
  } catch {
    emailError.value = 'Something went wrong. Please try again.';
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <AuthLayout title="Resend unlock instructions" :top-links="topLinks" :bottom-links="bottomLinks">
    <div v-if="success" class="text-white/80 text-base leading-relaxed">
      We've resent the unlock instructions to your provided email.
    </div>

    <form v-else @submit.prevent="handleSubmit">
      <Input v-model="email" type="email" placeholder="Email" autocomplete="email" :error="emailError" />

      <div class="mt-form-gap">
        <Button type="submit" variant="primary" size="lg" :loading="loading" :disabled="loading">
          Resend unlock instructions
        </Button>
      </div>
    </form>
  </AuthLayout>
</template>
